import React from 'react';

function LoadError({ onRetry }) {
  return (
    <div className="px-4 py-16 text-center">
      <p className="text-base-content/70">Couldn't load the photos. Check your connection and try again.</p>
      <button onClick={onRetry} className="btn btn-outline mt-4">
        Try again
      </button>
    </div>
  );
}

export default LoadError;
